import styled from 'styled-components'

export const EmptyDivElement = styled.div`
  width: auto;
`

export const EmptySpanElement = styled.span`
  width: auto;
`
